export const inputId = {
  wrapper: 'wrapper',
  input: 'input',
  error: 'error',
  label: 'label',
  tip: 'tip',
  items: 'items',
  unit: 'unit',
  plusMinus: 'plus-minus',
  plus: 'plus',
  minus: 'minus',
  slider: 'slider'
}
